import { Address } from './address.model';

export class PayerData {
  firstName: string;
  lastName: string;
  genderId: number;
  address: Address;
}
